import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { Link, useHistory } from 'react-router-dom'
import auth from '../../utils/auth'
import { reset } from '../../features/account/slice'
import { useDispatch, useSelector } from 'react-redux'
import { useProfile } from './profile-hook'
import { useInternationalization } from '../../features/i18n'

const Avatar = ({profile, small, className, ...props}) => {
  const size = small === true ? '30px' : '40px'
  const backgroundImage = `url('${profile.image ? profile.image : '/images/khub_anwar.jpg'}')`

  return (
    <div
      style={{backgroundImage, height: size, width: size, backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
      className={`bg-no-repeat bg-center rounded-full shadow ${className}`}
      {...props}
    />
  )
}

const MemberDropdown = ({small}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { profile } = useProfile()
  const { translate, language } = useInternationalization()
  const { statusName } = useSelector(state => state.account.profile)
  const { tickets = [] } = useSelector(state => state.account)

  const handleSignOut = () => {
    dispatch(reset())
    auth().logout()
    history.push('/login')
  }

  const title = statusName ? statusName[language.name] : translate('ORGANIZATION', 'member')
  const ticketCount = tickets.length

  return (
    <React.Fragment>
      <Dropdown>
        <DropdownTrigger>
          <Avatar profile={profile} small={small} />
        </DropdownTrigger>
        <DropdownContent>
          <div className="flex p-5 border-b" style={{borderColor: '#eee'}}>
            <Avatar profile={profile} small={small} className="mr-2"/>
            <Link to={`/profile/${profile.userId}`}>
              <div>
                <p className="font-primary normal-case text-base font-bold">{profile.name}</p>
                <p className="font-primary normal-case font-normal text-xs text-gray-999">
                  {title}
                </p>
              </div>
            </Link>
          </div>
          <div>
            <ul className="p-5 font-primary normal-case font-normal border-b" style={{borderColor: '#eee'}}>
              <li className="mb-2">
                <Link to="/dashboard/profile">
                  {translate('DASHBOARD', 'my_profile')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/tickets">
                  {translate('DASHBOARD', 'event_tickets')} ({ticketCount})
                </Link>
              </li>
            </ul>
            <ul className="p-5 font-primary normal-case font-normal">
              <li className="mb-2">
                <Link to="/dashboard/bookmarks">
                  {translate('BOOKMARK', 'plural')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/dashboard/settings">
                  {translate('DASHBOARD', 'account_settings')}
                </Link>
              </li>
              <li className="mb-2">
                <p className="font-primary font-normal" onClick={handleSignOut}>
                  {translate('AUTH', 'logout')}
                </p>
              </li>
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { MemberDropdown }
